import { baseAPI } from "../baseApi";

export const roadInfoApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение информации о дороге
        fetchRoadInfo: builder.query<any, any>({
            query: ({ roadId }) => ({
                url: `address/Roads(${roadId})`
            })
        })
    })
})

export const {
    useFetchRoadInfoQuery,
} = roadInfoApiSlice


